module.exports = __webpack_public_path__ + "img/instagram.6117d7e6.png";